// Product Hunt launch window — single source of truth for the
// `/launch` page banner gate, the home `?ref=ph` overlay, and the
// "ends Wednesday" copy on the discount strip. After T+7 (END_AT)
// every PH-only banner stops rendering and the discount visuals
// fall back to the regular pricing page.
//
// Update these timestamps if launch slips — the renderer reads these,
// not a launch doc.
//
// Times are PT (Pacific) since that's the Product Hunt day boundary.
export const LAUNCH_START_AT = new Date("2026-05-14T00:00:00-07:00");
export const LAUNCH_END_AT = new Date("2026-05-21T23:59:59-07:00");

/**
 * `true` while we're inside the Product Hunt launch window. Cheap enough
 * to call on every render — `Date.now()` is the only cost.
 */
export function isLaunchActive(now: Date = new Date()): boolean {
  return now.getTime() <= LAUNCH_END_AT.getTime();
}

/**
 * `true` when the current page should surface the launch banner. The
 * `/launch` page always opts in regardless of the query param so warm
 * traffic that lands directly on it still sees the discount strip.
 */
export function shouldShowLaunchBanner(opts: {
  pathname: string;
  search: string;
}): boolean {
  if (!isLaunchActive()) return false;
  if (/\/launch(\/|$)/.test(opts.pathname)) return true;
  const params = new URLSearchParams(opts.search);
  return params.get("ref") === "ph";
}

/** localStorage key the dismiss button writes to. Scoped to the launch
 *  window — bumps each season so re-launches re-show the banner. */
export const LAUNCH_DISMISS_KEY = "minuta:launch:2026-05:dismissed";
